import services from "../services";
import * as types from "./mutation-type";

export const actionGetTokenRecaptcha = ({commit}, payload) => {
    grecaptcha.ready(() => {
        grecaptcha.execute(grecaptcha.clientId, {
            action: payload.action
        })
        .then(token => {
            commit(types.SET_TOKEN, token)
        })
    })
}